/* eslint-disable @typescript-eslint/camelcase */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { loadGoogleAuth } from '../redux/user.redux';

interface CredentialResponse {
  credential?: string;
  select_by?:
    | 'auto'
    | 'user'
    | 'user_1tap'
    | 'user_2tap'
    | 'btn'
    | 'btn_confirm'
    | 'brn_add_session'
    | 'btn_confirm_add_session';
  clientId?: string;
}

type Props = {
  context?: 'signin' | 'signup';
  type?: 'dark' | 'light';
};

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const GoogleAuthButton = (props: Props) => {
  const { context = 'signin' } = props;

  const dispatch = useDispatch();
  const [gsiScriptLoaded, setGsiScriptLoaded] = useState(false);

  const handleGoogleSignIn = (res: CredentialResponse) => {
    if (!res.clientId || !res.credential) return;

    dispatch(loadGoogleAuth(res.credential));
  };

  const loadButton = () => {
    // Enabling it shows the popup
    // window.google.accounts.id.prompt();

    window.google.accounts.id.renderButton(document.getElementById('google-auth-button'), {
      theme: 'filled_blue',
      shape: 'rectangular',
      type: 'standard',
      size: 'large',
      width: 240,
      text: context === 'signin' ? 'signin_with' : 'signup_with',
      logo_alignment: 'left'
    });
  };

  useEffect(() => {
    if (gsiScriptLoaded) {
      loadButton();
      return;
    }

    const initializeGsi = () => {
      if (!window.google || gsiScriptLoaded) return;

      setGsiScriptLoaded(true);

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleGoogleSignIn,
        context
      });

      loadButton();
    };

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = initializeGsi;
    script.async = true;
    script.id = 'google-client-script';
    document.querySelector('body')?.appendChild(script);

    return () => {
      window.google?.accounts.id.cancel();
      document.getElementById('google-client-script')?.remove();
    };
  }, [context, gsiScriptLoaded, handleGoogleSignIn]);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}
    >
      <div id="google-auth-button" data-context="signup" />
    </div>
  );
};

export default GoogleAuthButton;
